import styled from 'styled-components';
import { Base, CardTileList } from 'styled';

export const Container = styled(Base)`
  display: flex;
  flex-direction: column;
  margin: 0 auto 1.5rem;
  max-width: ${({ theme }) => theme.sizes.cardTileListMaxWidth};
`;

export const CardsContainer = styled(CardTileList)`
  margin: 1rem 2rem 1.5rem;
`;
